import { create } from "apisauce";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const getToken = async () => {
  try {
    return await cookies.get("access_token");
  } catch (e) {
    console.log("Error getting access token: " + e);
  }
};

const privateAPIClient = create({
  baseURL: process.env.REACT_APP_LEADS_API_BASE_URL,
  // authURL: settings.AUTH_API_BASE_URL,
});

privateAPIClient.addAsyncRequestTransform(async (request) => {
  const authToken = await getToken();
  console.log("🚀 lead", authToken);
  if (!authToken) {
    console.log("------invalid Access------");
    return;
  }

  request.headers["Authorization"] = "Bearer " + authToken;
  // request.headers["Content-Type"] = "multipart/form-data";
  request.headers["Content-Type"] = "application/json";
  // request.headers["Accept"] = "*/*";
  // if not working remove return
  return request;
});

privateAPIClient.addResponseTransform(
  (response) => {
    // const navigate = useNavigate();

    if (response.status === 401) {
      cookies.remove("access_token");
      cookies.remove("refresh_token");
      localStorage.clear();
      window.location.href = "/login";
      // alert("Session is Expired");
    }
  },
  () => {
    console.log("<><><><><><><><><><><><><>");
  }
);

export default privateAPIClient;
